import { format, addDays, startOfWeek, parseISO, isValid } from "date-fns";
import { it } from "date-fns/locale";

export const ISO = (d) => format(d, "yyyy-MM-dd");
export const parseISODate = (s) => {
  if (!s) return null;
  const d = parseISO(s);
  return isValid(d) ? d : null;
};
export const fmtLong = (d) => format(d, "EEEE d MMMM yyyy", { locale: it });
export const fmtShort = (d) => format(d, "EEE d", { locale: it });
export const fmtDayNum = (d) => format(d, "d", { locale: it });
export const fmtWeekday = (d) => format(d, "EEE", { locale: it });
export const fmtMonthYear = (d) => format(d, "MMMM yyyy", { locale: it });

export function weekStart(d) {
  return startOfWeek(d, { weekStartsOn: 1 });
}

export function weekDays(d) {
  const start = weekStart(d);
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
}

export function weekRangeLabel(d) {
  const s = weekStart(d);
  const e = addDays(s, 6);
  const sameMonth = format(s, "M") === format(e, "M");
  if (sameMonth) {
    return `${format(s, "d", { locale: it })} – ${format(e, "d MMM yyyy", { locale: it })}`;
  }
  return `${format(s, "d MMM", { locale: it })} – ${format(e, "d MMM yyyy", { locale: it })}`;
}

// Convert HH:MM to minutes from midnight
export function timeToMin(t) {
  if (!t) return null;
  const [h, m] = t.split(":").map(Number);
  return h * 60 + m;
}

// Convert minutes to HH:MM
export function minToTime(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
}

export function slotOfDay(time) {
  const m = timeToMin(time);
  if (m == null) return "senza-orario";
  if (m < 14 * 60) return "mattina";
  if (m < 18 * 60) return "pomeriggio";
  return "sera";
}
